import { safeLocalStorage } from './safeLocalStorage';
import type { ThemePreferenceType } from '@/styles/types';
import { THEME_PREFERENCES } from '@/styles/constants';

export const getSavedThemePreference = (): ThemePreferenceType => {
  const savedTheme =
    safeLocalStorage.getItem('ui.theme-preference') || THEME_PREFERENCES.LIGHT;
  return savedTheme;
};
